"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PopupManager_1 = __importDefault(require("../../PopupManager/PopupManager"));
var DesktopMenu_styles_1 = require("./DesktopMenu-styles");
var DesktopMenu = function (_a) {
    var mainMenu = _a.mainMenu, onMainMenuChange = _a.onMainMenuChange;
    var mainMenuItems = mainMenu === null || mainMenu === void 0 ? void 0 : mainMenu.map(function (item, key) {
        var MainItem = function (_a) {
            var isOpen = _a.isOpen;
            return (React.createElement(DesktopMenu_styles_1.MainMenuItemElem, { isOpen: isOpen || item.isSelected, href: item.url, onClick: function (e) {
                    e.preventDefault();
                    onMainMenuChange(item);
                } }, item.title));
        };
        return item.subItems ? (React.createElement(PopupManager_1.default, { key: key, onHover: true, element: function () { return React.createElement(MainItem, null); } }, function (onClose) {
            var _a;
            return (React.createElement(DesktopMenu_styles_1.MainMenuSubItemWrapper, null,
                React.createElement(DesktopMenu_styles_1.MainMenuSubItems, null, (_a = item.subItems) === null || _a === void 0 ? void 0 : _a.map(function (subItem, key2) {
                    if (subItem.url) {
                        return (React.createElement(DesktopMenu_styles_1.MainMenuSubItemLink, { key: key2, onClick: function (e) {
                                e.preventDefault();
                                onMainMenuChange(subItem);
                                onClose === null || onClose === void 0 ? void 0 : onClose();
                            }, href: subItem.url }, subItem.title));
                    }
                }))));
        })) : (React.createElement(MainItem, { key: key }));
    });
    return React.createElement(DesktopMenu_styles_1.MainMenu, null, mainMenuItems);
};
exports.default = DesktopMenu;
